var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { GridContext } from '../hooks/useGridContext';
const StyledGridArea = styled.div `
  /* Position inside the surrounding grid */
  grid-column-start: ${p => (p.colStart || 0) + 1};
  grid-column-end: ${p => (p.colStart || 0) + 1 + (p.colWidth || 1)};
  grid-row-start: ${p => (p.rowStart || 0) + 1};
  grid-row-end: ${p => (p.rowStart || 0) + 1 + (p.rowHeight || 1)};

  /* Content Alignment (enforced by a CSS sub-grid if applicable) */
  display: ${p => (p.contentAlignH || p.contentAlignV ? 'grid' : undefined)};
  align-items: ${p => p.contentAlignV};
  justify-content: ${p => p.contentAlignH};
`;
export function GridArea(_a) {
    var { children, colWidth = undefined } = _a, rest = __rest(_a, ["children", "colWidth"]);
    return (React.createElement(GridContext.Provider, { value: { availableColumns: colWidth || 1 } },
        React.createElement(StyledGridArea, Object.assign({ colWidth: colWidth }, rest), children)));
}
